import Vue from "vue";
import VueI18n from "vue-i18n";

// Localisation language list
import { locale as en_GB } from "@/core/config/i18n/en_GB";
import { locale as fr_FR } from "@/core/config/i18n/fr_FR";

Vue.use(VueI18n);

let messages = {};
messages = { ...messages, en_GB, fr_FR };

// get current selected language
const fallbackLocale = "fr_FR";
const lang = localStorage.getItem("language") || fallbackLocale;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: fallbackLocale,
  messages // set locale messages
});

export default i18n;
